import React, { useState, useEffect } from "react";
import { logoEli } from "../../assets";
import "./style.css";
import PolicyFooter from "../Policy/PolicyFooter";
import "../Policy/policy.css";
import {
  CardBodyComp,
  ImageProgressPage,
  ModalConfirmSkipEarlyBird,
  ModalEarlyBird,
  ModalNonEarlyBird,
  SummaryPembayaranIndividu,
} from "../../components/moleculs";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import axios from "../../lib/axios";
import axiosSf from "../../lib/axios-sf";
import { MySwal } from "../../lib/swal";
import errorHandler from "../../helpers/errorHandler";
import { isStrongPassword, PASSWORD_RULE_TEXT } from "../../helpers/passwordPolicy";
import { useLocation } from "react-router-dom";

const RegistrationPage = () => {
  const [isPaymentManual, setIsPaymentManual] = useState(false)
  const [triggerCheckout, setTriggerCheckout] = useState(false)
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const validateProgramParticipants = useSelector(
    (state) => state.validateProgramParticipants
  );
  const categoryUser = useSelector((state) => state.categoryUserSelected);
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const programSelected = useSelector((state) => state.programSelected);
  const bpSelected = useSelector((state) => state.bpSelected);
  const scheduleSelected = useSelector((state) => state.scheduleSelected);
  const bpScheduleSelected = useSelector((state) => state.bpScheduleSelected);
  const metodePembayaranSelected = useSelector(
    (state) => state.metodePembayaranCorporateSelected
  );
  const participants = useSelector((state) => state.participants);

  const [showPembayaranIndividu, setShowPembayaranIndividu] = useState(false);

  const [showOpsiBtnBayar, setshowOpsiBtnBayar] = useState(false);
  const [showModalEarlyBird, setshowModalEarlyBird] = useState(false);
  const [showModalNonEarlyBird, setshowModalNonEarlyBird] = useState(false);
  const [showModalInfoSkipEarlyBird, setshowModalInfoSkipEarlyBird] =
    useState(false);

  const corporateParticipants = [];
  const individuParticipants = [];

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const [page, setPage] = useState(1);

  const handleCheckParticipants = () => {
    for (const item of scheduleSelected) {
      if (item.participants.length === 0) {
        MySwal.fire({
          icon: "warning",
          title: "Oops, Kesalahan!",
          text: "Pastikan Program terpilih sudah memiliki Peserta.",
        });
        return false;
      }
    }
    // If all items have participants, return true or proceed as necessary
    return true;
  };

  const next = () => {
    if (page === 1) {
      if (
        dataInputRegistration.sumberInformasi.length > 0 &&
        dataInputRegistration.namaBelakangPic.length > 0 &&
        dataInputRegistration.emailPic.length > 0 &&
        dataInputRegistration.codeHpPic.length > 0 &&
        dataInputRegistration.passwordPic.length > 0 &&
        dataInputRegistration.salutationIndividu.length > 0 &&
        dataInputRegistration.hpPic.length > 8 &&
        dataInputRegistration.konfirmasiPasswordPic.length > 0
      ) {
        // Regular expression pattern for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailRegex.test(dataInputRegistration.emailPic);
        if (isValidEmail !== true) {
          MySwal.fire({
            icon: "warning",
            title: "Oops, Kesalahan!",
            text: "Alamat Email tidak valid.",
            confirmButtonColor: "#6e7d88",
          });
        } else if (!isStrongPassword(dataInputRegistration.passwordPic)) {
          MySwal.fire({
            icon: "warning",
            title: "Oops, Password terlalu lemah!",
            text: `Password harus ${PASSWORD_RULE_TEXT}`,
            confirmButtonColor: "#6e7d88",
          });
        } else {
          if (
            dataInputRegistration.passwordPic !==
            dataInputRegistration.konfirmasiPasswordPic
          ) {
            MySwal.fire({
              icon: "warning",
              title: "Oops, Kesalahan!",
              text: "Konfirmasi Password belum valid.",
              confirmButtonColor: "#6e7d88",
            });
          } else {
            setPage(2);
            dispatch({ type: "SET_INPUT_ALERT", value: false });
            handlePostLeads();
          }
        }
      } else {
        if (
          dataInputRegistration.sumberInformasi.length > 0 &&
          dataInputRegistration.namaBelakangPic.length > 0 &&
          dataInputRegistration.emailPic.length > 0 &&
          dataInputRegistration.codeHpPic.length > 0 &&
          dataInputRegistration.passwordPic.length > 0 &&
          dataInputRegistration.hpPic.length < 9 &&
          dataInputRegistration.konfirmasiPasswordPic.length > 0
        ) {
          MySwal.fire({
            icon: "warning",
            title: "Oops, Kesalahan!",
            text: "Nomor Handphone minimal 9 digit.",
          });
        }
        dispatch({ type: "SET_INPUT_ALERT", value: true });
      }
    } else if (page === 2) {
      if (programSelected.length > 0) {
        if (programSelected.length !== scheduleSelected.length) {
          MySwal.fire({
            icon: "warning",
            title: "Oops, Kesalahan!",
            text: "Pastikan Program terpilih sudah memiliki Jadwal.",
            confirmButtonColor: "#6e7d88",
          });
        } else {
          setPage(3);
          dispatch({ type: "SET_INPUT_ALERT", value: false });
        }
      } else {
        if (bpSelected.length > 0) {
          const totalPanjangBpi = bpSelected.reduce(
            (total, obj) => total + obj.BundlingProgramItems.length,
            0
          );
          if (totalPanjangBpi !== bpScheduleSelected.length) {
            MySwal.fire({
              icon: "warning",
              title: "Oops, Kesalahan!",
              text: "Pastikan Program Bundling terpilih sudah memiliki Jadwal.",
              confirmButtonColor: "#6e7d88",
            });
          } else {
            setPage(3);
            dispatch({ type: "SET_INPUT_ALERT", value: false });
          }
        } else {
          dispatch({ type: "SET_INPUT_ALERT", value: true });
        }
      }
    } else if (page === 3) {
      if (dataInputRegistration.syaratKetentuan === true) {
        setPage(4);
        dispatch({ type: "SET_INPUT_ALERT", value: false });
      } else {
        MySwal.fire({
          icon: "warning",
          title: "Oops, Kesalahan!",
          text: "Anda belum menyetujui Syarat dan Ketentuan.",
          confirmButtonColor: "#6e7d88",
        });
        dispatch({ type: "SET_INPUT_ALERT", value: true });
      }
    } else if (page === 4 && categoryUser.value === "individu") {
      if (
        dataInputRegistration.salutationIndividu.length > 0 &&
        dataInputRegistration.sumberInformasi.length > 0 &&
        dataInputRegistration.namaBelakangPic.length > 0 &&
        dataInputRegistration.emailPic.length > 0 &&
        dataInputRegistration.codeHpPic.length > 0 &&
        dataInputRegistration.kartuIdentitasIndividu.length > 0 &&
        dataInputRegistration.nikIndividu.length > 0 &&
        dataInputRegistration.filekartuIdentitasIndividu.name !== undefined &&
        dataInputRegistration.provinsiIdIndividu.length > 0 &&
        dataInputRegistration.kotaIdIndividu.length > 0 &&
        dataInputRegistration.kecamatanIdIndividu.length > 0 &&
        dataInputRegistration.kodeposIndividu.length > 0 &&
        dataInputRegistration.patokanIndividu.length > 0 &&
        dataInputRegistration.pekerjaanIndividu.length > 0
      ) {
        handleGetSubTotal();
        // setTimeout(() => {
        //   setPage(5);
        // }, 1000);
        dispatch({ type: "SET_INPUT_ALERT", value: false });
      } else {
        dispatch({ type: "SET_INPUT_ALERT", value: true });
      }
    } else if (page === 4 && categoryUser.value === "corporate") {
      if (
        dataInputRegistration.namaPerusahaan.length > 0 &&
        dataInputRegistration.jenisPerusahaan.length > 0 &&
        dataInputRegistration.klasifikasiIndustri.length > 0 &&
        // dataInputRegistration.klasifikasiIndustriOther.length &&
        dataInputRegistration.stringNpwpPerusahaan.length > 0 &&
        dataInputRegistration.fileNpwpPerusahaan.name !== undefined &&
        dataInputRegistration.teleponPerusahaan.length > 0 &&
        dataInputRegistration.provinsiPerusahaan.length > 0 &&
        dataInputRegistration.kotaPerusahaan.length > 0 &&
        dataInputRegistration.kecamatanPerusahaan.length > 0 &&
        dataInputRegistration.kodeposPerusahaan.length > 0 &&
        dataInputRegistration.patokanPerusahaan.length > 0
      ) {
        // alert('masuk atas')
        if (
          dataInputRegistration.pengirimanDokumenKeAlamatPerusahaan === true
        ) {
          if (
            dataInputRegistration.provinsiPerusahaanPengirimanDokumen.length >
            0 &&
            dataInputRegistration.kotaPerusahaanPengirimanDokumen.length > 0 &&
            dataInputRegistration.kecamatanPerusahaanPengirimanDokumen.length >
            0 &&
            dataInputRegistration.kodeposPerusahaanPengirimanDokumen.length >
            0 &&
            dataInputRegistration.patokanPerusahaanPengirimanDokumen.length > 0
          ) {
            setPage(4.5);
            dispatch({ type: "SET_INPUT_ALERT", value: false });
          } else {
            dispatch({ type: "SET_INPUT_ALERT", value: true });
          }
        } else {
          setPage(4.5);
          dispatch({ type: "SET_INPUT_ALERT", value: false });
        }
      } else {
        // alert('masuk bawah')

        dispatch({ type: "SET_INPUT_ALERT", value: true });
      }
    } else if (page === 4.5 && categoryUser.value === "corporate") {
      if (handleCheckParticipants()) {
        handleGetSubTotal();
        // setTimeout(() => {
        //   setPage(5);
        // }, 1000);
      }
    } else if (page === 5 && categoryUser.value === "corporate") {
      if (
        dataInputRegistration.isUsingEarlyBird === false &&
        bpSelected.length === 0
      ) {
        setshowModalInfoSkipEarlyBird(true);
      } else {
        setPage(6);
      }
    } else if (page === 6 && categoryUser.value === "corporate") {
      setPage(8);
    } else if (page === 5 && categoryUser.value === "individu") {
      setShowPembayaranIndividu(true);
    }
  };

  const previous = () => {
    if (page === 2) {
      setPage(1);
    } else if (page === 3) {
      setPage(2);
    } else if (page === 4) {
      setPage(3);
    } else if (page === 5 && categoryUser.value === "individu") {
      setPage(4);
    } else if (page === 4.5 && categoryUser.value === "corporate") {
      setPage(4);
    } else if (page === 5 && categoryUser.value === "corporate") {
      setPage(4.5);
    } else if (page === 6 && categoryUser.value === "corporate") {
      setPage(5);
    } else if (page === 7 && categoryUser.value === "individu") {
      setPage(5);
    } else if (page === 8 && categoryUser.value === "corporate") {
      setPage(6);
    }
  };

  const handleLogin = () => {
    history.push("login");
  };

  const cekStatusPembayaranIndividu = () => {
    window.location.href = "/riwayat-transaksi";
  };

  const handleGetSubTotal = () => {
    // alert(categoryUser.value)
    if (
      categoryUser.value === "individu" ||
      categoryUser.value === "individual"
    ) {
      let scheduleIds = ""; // eslint-disable-line

      scheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: null,
            userCategory: "individu",
            isBundling: "false",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      bpScheduleSelected.forEach((schedule, i) => {
        individuParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: schedule.bpId,
            userCategory: "individu",
            isBundling: "true",
            participants: [
              {
                firstName: dataInputRegistration.namaDepanPic,
                lastName: dataInputRegistration.namaBelakangPic,
                email: dataInputRegistration.emailPic,
              },
            ],
          })
        );
      });

      const requestBody = {
        SchedulesId: individuParticipants,
        referralCode: "",
        useEarlyBird: bpScheduleSelected.length > 0 ? "no" : "",
      };

      axios({
        url: "/users/transactions/nominalPayments",
        method: "POST",
        data: requestBody,
      })
        .then((res) => {
          // console.log(res?.data?.data)
          dispatch({
            type: "SET_NOMINAL_PAYMENT",
            nominalPayment: res.data.data,
          });
          if (
            res?.data?.data?.deductionItems?.[0]?.[0]?.label === "Early Bird" &&
            bpScheduleSelected.length === 0
          ) {
            dispatch({ type: "SET_USING_EARLY_BIRD", value: true });
            dispatch({ type: "SET_EARLY_BIRD", value: true });
            setshowModalEarlyBird(true);
            setshowModalNonEarlyBird(false);
          } else {
            dispatch({ type: "SET_EARLY_BIRD", value: false });
            dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
            setshowModalEarlyBird(false);
            setshowModalNonEarlyBird(true);
          }
        })
        .catch((err) => {
          if (err !== "") {
            errorHandler({ err: err?.response?.data || err });
            console.log(err);
          }
        });
    } else {
      var scheduleIds = ""; // eslint-disable-line
      scheduleSelected.forEach((schedule, i) => {
        corporateParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: null,
            userCategory: "corporate",
            isBundling: "false",
            participants: schedule.participants,
          })
        );
      });

      bpScheduleSelected.forEach((schedule, i) => {
        corporateParticipants.push(
          (scheduleIds = {
            id: schedule.scheduleId,
            bpId: schedule.bpId,
            userCategory: "corporate",
            isBundling: "true",
            participants: schedule.participants,
          })
        );
      });

      const requestBody = {
        SchedulesId: corporateParticipants,
        referralCode: "",
        useEarlyBird: bpScheduleSelected.length > 0 ? "no" : "",
      };

      // console.log(requestBody)

      axios({
        url: "/users/transactions/nominalPayments",
        method: "POST",
        data: requestBody,
      })
        .then((res) => {
          // console.log(res?.data?.data)
          if (res.data.data.code === "200") {
            dispatch({
              type: "SET_NOMINAL_PAYMENT",
              nominalPayment: res.data.data,
            });
          }

          if (
            res?.data?.data?.deductionItems?.[0]?.[0]?.label === "Early Bird" &&
            bpScheduleSelected.length === 0
          ) {
            setshowModalEarlyBird(true);
            setshowModalNonEarlyBird(false);
          } else {
            setshowModalEarlyBird(false);
            setshowModalNonEarlyBird(true);
            dispatch({ type: "SET_EARLY_BIRD", value: false });
            dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
          }
        })
        .catch((err) => {
          if (err !== "") {
            errorHandler({ err: err?.response?.data || err });
            console.log(err);
          }
        });
    }
  };

  const handlePostLeads = () => {
    const requestBody = {
      firstName: dataInputRegistration.namaDepanPic,
      lastName: dataInputRegistration.namaBelakangPic,
      email: dataInputRegistration.emailPic,
      mobilePhone: dataInputRegistration.codeHpPic.concat(
        dataInputRegistration.hpPic
      ),
      informationSource: dataInputRegistration.sumberInformasi,
    };

    axios({
      url: "/users/leads",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res.data)
      })
      .catch((err) => {
        if (err !== "") {
          errorHandler({ err: err?.response?.data || err });
          console.log(err);
        }
      });
  };

  useEffect(() => {
    window.dataLayer.push({
      event: "pageview",
      page: {
        url: window.location.pathname + window.location.search,
        title: document.title,
      },
    });
  }, [location]);

  const handleActivateEarlyBirdAgain = () => {
    var scheduleIds = ""; // eslint-disable-line
    scheduleSelected.forEach((schedule, i) => {
      corporateParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: null,
          userCategory: "corporate",
          isBundling: "false",
          participants: schedule.participants,
        })
      );
    });

    bpScheduleSelected.forEach((schedule, i) => {
      corporateParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: schedule.bpId,
          userCategory: "corporate",
          isBundling: "true",
          participants: schedule.participants,
        })
      );
    });

    const requestBody = {
      SchedulesId: corporateParticipants,
      referralCode: "",
      useEarlyBird: bpScheduleSelected.length > 0 ? "no" : "",
    };

    axios({
      url: "/users/transactions/nominalPayments",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res?.data?.data)
        if (res.data.data.code === "200") {
          dispatch({
            type: "SET_NOMINAL_PAYMENT",
            nominalPayment: res.data.data,
          });
        }

        if (
          res?.data?.data?.deductionItems?.[0]?.[0]?.label === "Early Bird" &&
          bpScheduleSelected.length === 0
        ) {
          dispatch({ type: "SET_USING_EARLY_BIRD", value: true });
          dispatch({ type: "SET_EARLY_BIRD", value: true });
          setshowModalInfoSkipEarlyBird(false);
        } else {
          dispatch({ type: "SET_EARLY_BIRD", value: false });
          dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
          setshowModalInfoSkipEarlyBird(false);
        }
      })
      .catch((err) => {
        if (err !== "") {
          errorHandler({ err: err?.response?.data || err });
          console.log(err);
        }
      });
  };

  const handleActivateEarlyBird = () => {
    // console.log("masuk handleActivateEarlyBird")
    dispatch({ type: "SET_USING_EARLY_BIRD", value: true });
    dispatch({ type: "SET_EARLY_BIRD", value: true });
    dispatch({ type: "SET_USING_REFERRAL", value: false });
    setPage(5);
    setshowModalEarlyBird(false);
    setshowModalNonEarlyBird(false);
    setshowModalInfoSkipEarlyBird(false);
  };

  const handleToGlPage = () => {
    setIsPaymentManual(true)
    setPage(6);
    setshowModalInfoSkipEarlyBird(false);
  };

  const handleSkipEarlyBird = () => {
    handleNotUsingEarlyBird();
    dispatch({ type: "SET_EARLY_BIRD", value: true });
    setPage(5);
    setshowModalEarlyBird(false);
    setshowModalNonEarlyBird(false);
  };

  const handleNotUsingEarlyBird = () => {
    dispatch({ type: "SET_USING_EARLY_BIRD", value: false });
    var scheduleIds = ""; // eslint-disable-line
    scheduleSelected.forEach((schedule, i) => {
      corporateParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: null,
          userCategory: "corporate",
          isBundling: "false",
          participants: schedule.participants,
        })
      );
    });

    bpScheduleSelected.forEach((schedule, i) => {
      corporateParticipants.push(
        (scheduleIds = {
          id: schedule.scheduleId,
          bpId: schedule.bpId,
          userCategory: "corporate",
          isBundling: "true",
          participants: schedule.participants,
        })
      );
    });

    const requestBody = {
      SchedulesId: corporateParticipants,
      referralCode: "",
      useEarlyBird: "no",
    };

    axios({
      url: "/users/transactions/nominalPayments",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res?.data?.data)
        // return false
        dispatch({
          type: "SET_NOMINAL_PAYMENT",
          nominalPayment: res.data.data,
        });
      })
      .catch((err) => {
        if (err !== "") {
          errorHandler({ err: err?.response?.data || err });
          console.log(err);
        }
      });
  };

  const handleOpsiBtnBayar = () => {
    setshowModalNonEarlyBird(false);
    setshowOpsiBtnBayar(true);
    setPage(5);
  };

  const handleCheckout = async () => {
    try {
      // Validasi: picMobilePhone, picIdentityNumber, companyPhone hanya boleh angka
      const onlyDigitsRegex = /^\d+$/;
      const numericFields = [
        { value: dataInputRegistration.hpPic, label: "Nomor Handphone" },
        { value: dataInputRegistration.nikIndividu, label: "Nomor Identitas (NIK)" },
        { value: dataInputRegistration.teleponPerusahaan, label: "Nomor Telepon Perusahaan" },
      ];
      const invalidField = numericFields.find(
        (field) => field.value && field.value.length > 0 && !onlyDigitsRegex.test(field.value)
      );
      if (invalidField) {
        MySwal.fire({
          icon: "warning",
          title: "Oops, Kesalahan!",
          text: `${invalidField.label} hanya boleh diisi dengan angka.`,
          confirmButtonColor: "#6e7d88",
        });
        return false;
      }

      dispatch({ type: 'SET_DISABLED_REGISTRATION', 'value': true });
      // console.log("isPaymentManual:", isPaymentManual)
      // return false
      const formData = new FormData();
      // post for trx existing
      formData.append("isExisting", "no");
      // formData.append("UserId", null);
      // global
      formData.append("accountType", categoryUser.value === "corporate" ? "corporate" : "individual");
      formData.append("useEarlyBird", dataInputRegistration.isUsingEarlyBird === true ? "yes" : "no");
      // global
      formData.append("salutation", dataInputRegistration.salutationIndividu);
      // global
      formData.append("picFirstName", dataInputRegistration.namaDepanPic);
      // global
      formData.append("picLastName", dataInputRegistration.namaBelakangPic);
      // global
      formData.append("picEmail", dataInputRegistration.emailPic);
      // global
      formData.append("picPassword", dataInputRegistration.passwordPic);
      // global
      formData.append(
        "picMobilePhone",
        dataInputRegistration.codeHpPic.concat(dataInputRegistration.hpPic)
      );
      // global
      formData.append(
        "picInformationSource",
        dataInputRegistration.sumberInformasi
      );
      // global
      formData.append("referralCode", dataInputRegistration.refCode);
      // global
      formData.append("companyBillingCountry", "Indonesia");
      formData.append(
        "companyBillingState",
        categoryUser.value === "corporate" ? dataInputRegistration.provinsiPerusahaan : dataInputRegistration.provinsiIndividu
      );
      formData.append("companyBillingCity",
        categoryUser.value === "corporate" ?
          dataInputRegistration.kotaPerusahaan :
          dataInputRegistration.kotaIndividu);
      formData.append(
        "companyBillingSubdistrict",
        categoryUser.value === "corporate" ?
          dataInputRegistration.kecamatanPerusahaan :
          dataInputRegistration.kecamatanIndividu
      );
      formData.append(
        "companyBillingStreet",
        categoryUser.value === "corporate" ?
          dataInputRegistration.patokanPerusahaan :
          dataInputRegistration.patokanIndividu
      );
      formData.append(
        "companyBillingZip",
        categoryUser.value === "corporate" ?
          dataInputRegistration.kodeposPerusahaan :
          dataInputRegistration.kodeposIndividu
      );
      // individu
      formData.append(
        "picIdentityType",
        dataInputRegistration.kartuIdentitasIndividu
      );
      // individu
      formData.append("picIdentityNumber", dataInputRegistration.nikIndividu);
      // individu
      formData.append(
        "picCompanyName",
        dataInputRegistration.namaPerusahaanIndividu
      );
      // individu
      formData.append("picJob", dataInputRegistration.pekerjaanIndividu);
      // individu
      formData.append("picJobPosition", dataInputRegistration.jabatanIndividu);
      // corpo
      formData.append(
        "billingRequirement",
        dataInputRegistration.dokumenRequirementLainnya
      );
      // corpo
      formData.append("companyName", dataInputRegistration.namaPerusahaan);
      formData.append("npwp", dataInputRegistration.stringNpwpPerusahaan);

      if (categoryUser.value === "corporate") {
        formData.append("npwpFile", dataInputRegistration.fileNpwpPerusahaan);
      } else {
        formData.append("npwpFile", dataInputRegistration.filekartuIdentitasIndividu);
      }

      formData.append("companyType", dataInputRegistration.jenisPerusahaan);
      formData.append(
        "industryClassification",
        dataInputRegistration.klasifikasiIndustri ||
        dataInputRegistration.klasifikasiIndustriOther
      );
      formData.append("companyPhone", dataInputRegistration.teleponPerusahaan);
      // corpo
      formData.append("companyShippingCountry", "Indonesia");
      formData.append(
        "companyShippingState",
        dataInputRegistration.provinsiPerusahaanPengirimanDokumen.length > 0
          ? dataInputRegistration.provinsiPerusahaanPengirimanDokumen
          : dataInputRegistration.provinsiPerusahaan
      );
      formData.append(
        "companyShippingCity",
        dataInputRegistration.kotaPerusahaanPengirimanDokumen.length > 0
          ? dataInputRegistration.kotaPerusahaanPengirimanDokumen
          : dataInputRegistration.kotaPerusahaan
      );
      formData.append(
        "companyShippingSubdistrict",
        dataInputRegistration.kecamatanPerusahaanPengirimanDokumen.length > 0
          ? dataInputRegistration.kecamatanPerusahaanPengirimanDokumen
          : dataInputRegistration.kecamatanPerusahaan
      );
      formData.append(
        "companyShippingStreet",
        dataInputRegistration.patokanPerusahaanPengirimanDokumen.length > 0
          ? dataInputRegistration.patokanPerusahaanPengirimanDokumen
          : dataInputRegistration.patokanPerusahaan
      );
      formData.append(
        "companyShippingZip",
        dataInputRegistration.kodeposPerusahaanPengirimanDokumen.length > 0
          ? dataInputRegistration.kodeposPerusahaanPengirimanDokumen
          : dataInputRegistration.kodeposPerusahaan
      );

      if (categoryUser.value === "corporate") {
        if (isPaymentManual) {
          formData.append("paymentMethod", "manual");
        } else {
          formData.append("paymentMethod", "xendit");
        }
      } else {
        // individu
        formData.append("paymentMethod", "xendit");
      }

      if (
        dataInputRegistration.fileGLDanBuktiBayar !== ""
      ) {
        // corpo
        metodePembayaranSelected.value === "gl"
          ? formData.append("glFile", dataInputRegistration.fileGLDanBuktiBayar)
          : formData.append(
            "receiptFile",
            dataInputRegistration.fileGLDanBuktiBayar
          );
      } else {
        formData.append("glFile", "");
      }

      if (categoryUser.value === "corporate") {
        // corpo
        scheduleSelected.forEach((scheduleItem, idx) => {
          formData.append(`SchedulesId[${idx}][id]`, scheduleItem.scheduleId);
          formData.append(`SchedulesId[${idx}][isBundling]`, "false");
          formData.append(`SchedulesId[${idx}][bpId]`, "");
          formData.append(`SchedulesId[${idx}][numberOfParticipantBp]`, 0);
          scheduleItem.participants.forEach((participant, i) => {
            formData.append(
              `SchedulesId[${idx}][participants][${i}][firstName]`,
              participant.firstName
            );
            formData.append(
              `SchedulesId[${idx}][participants][${i}][lastName]`,
              participant.lastName
            );
            formData.append(
              `SchedulesId[${idx}][participants][${i}][email]`,
              participant.email
            );
            formData.append(
              `SchedulesId[${idx}][participants][${i}][mobilePhone]`,
              participant.mobilePhone
            );
            formData.append(
              `SchedulesId[${idx}][participants][${i}][position]`,
              participant.position
            );
          });
        });
      } else {
        // individu
        scheduleSelected.forEach((scheduleItem, index) => {
          formData.append(`SchedulesId[${index}][id]`, scheduleItem.scheduleId);
          formData.append(`SchedulesId[${index}][isBundling]`, "false");
          formData.append(`SchedulesId[${index}][bpId]`, "");
          formData.append(`SchedulesId[${index}][numberOfParticipantBp]`, 0);
        });
      }

      if (categoryUser.value === "corporate") {
        // corpo
        bpScheduleSelected.forEach((bpScheduleItem, i) => {
          formData.append(
            `SchedulesId[${i + scheduleSelected.length}][id]`,
            bpScheduleItem.scheduleId
          );
          formData.append(
            `SchedulesId[${i + scheduleSelected.length}][isBundling]`,
            "true"
          );
          formData.append(
            `SchedulesId[${i + scheduleSelected.length}][bpId]`,
            bpScheduleItem.bpId
          );
          formData.append(
            `SchedulesId[${i + scheduleSelected.length}][numberOfParticipantBp]`,
            bpScheduleItem.participants.length
          );
          bpScheduleItem.participants.forEach((participant, j) => {
            formData.append(
              `SchedulesId[${i + scheduleSelected.length
              }][participants][${j}][firstName]`,
              participant.firstName
            );
            formData.append(
              `SchedulesId[${i + scheduleSelected.length
              }][participants][${j}][lastName]`,
              participant.lastName
            );
            formData.append(
              `SchedulesId[${i + scheduleSelected.length
              }][participants][${j}][email]`,
              participant.email
            );
            formData.append(
              `SchedulesId[${i + scheduleSelected.length
              }][participants][${j}][mobilePhone]`,
              participant.mobilePhone
            );
            formData.append(
              `SchedulesId[${i + scheduleSelected.length
              }][participants][${j}][position]`,
              participant.position
            );
          });
        });
      } else {
        // individu
        bpScheduleSelected.forEach((bpScheduleItem, index) => {
          formData.append(
            `SchedulesId[${index + scheduleSelected.length}][id]`,
            bpScheduleItem.scheduleId
          );
          formData.append(
            `SchedulesId[${index + scheduleSelected.length}][isBundling]`,
            "true"
          );
          formData.append(
            `SchedulesId[${index + scheduleSelected.length}][bpId]`,
            bpScheduleItem.bpId
          );
          formData.append(
            `SchedulesId[${index + scheduleSelected.length
            }][numberOfParticipantBp]`,
            1
          );
        });
      }

      // Display the key/value pairs
      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
      // return false

      const { data } = await axios({
        url: `/users/transactions/checkout`,
        method: "POST",
        data: formData,
      });
      // console.log(data)

      if (data.code === '200') {
        // jika url xendit exist
        if (data.data.invoice_url && !isPaymentManual) {
          setShowPembayaranIndividu(false);
          MySwal.fire({
            icon: "success",
            title: "Registrasi Success",
            text: "Silahkan lakukan pembayaran sesuai email panduan yang telah kami kirimkan.",
          });
          setIsPaymentManual(false)
          // console.log("masuk success xendit")
          // return false
          setTimeout(() => {
            localStorage.setItem("access_token", data.data.token);
            window.location.href = "/riwayat-transaksi";
          }, 3000);
        }
        if (
          categoryUser.value === "corporate" &&
          isPaymentManual
        ) {
          setIsPaymentManual(false)
          // console.log("masuk success manual payment")
          // return false
          localStorage.setItem("access_token", data.data.token);
          dataInputRegistration.fileGLDanBuktiBayar !== ""
            ? dispatch({ type: "SET_CHECK_OUT_NOW", value: true })
            : dispatch({ type: "SET_CHECK_OUT_NOW", value: false });
          setPage(8);
          setShowPembayaranIndividu(false);
        }
      }
    } catch (err) {
      errorHandler({ err: err?.response?.data || err });
      console.log(err);
    } finally {
      // Selalu reset flag agar tombol tidak pernah terkunci di "Mohon Tunggu.."
      // walau response code tak terduga atau terjadi error apa pun.
      dispatch({ type: 'SET_DISABLED_REGISTRATION', 'value': false });
    }
  };

  const updateStateManualPayment = () => {
    // Step 1: ubah state manual payment
    setIsPaymentManual(true)
    // Step 2: kasih sinyal untuk jalanin handleCheckout nanti
    setTriggerCheckout(true)
  }

  useEffect(() => {
    // Step 3: setelah trigger berubah -> jalankan handleCheckout
    if (triggerCheckout) {
      handleCheckout()
      // reset trigger biar gak jalan terus
      setTriggerCheckout(false)
    }
  }, [triggerCheckout])

  // start_console_here
  // console.log("==================")
  // console.log(`categoryUser.value : ${categoryUser.value}`);
  // console.log(`isUsingReferral : ${dataInputRegistration.isUsingReferral}`);
  // console.log(`isUsingEarlyBird : ${dataInputRegistration.isUsingEarlyBird}`);
  // console.log("==================")

  return (
    <div className="row d-flex justify-content-center m-3">
      <div className="col-lg-12 header-registration-desktop">
        <img
          src={logoEli}
          alt="logoEli"
          width={size.width < 500 ? "40%" : "20%"}
          align="middle"
        />
        {size.width < 500 ? (
          <h1 style={{ fontSize: "14px" }} className="mt-1">
            Formulir Pendaftaran
          </h1>
        ) : (
          <h1 style={{ fontSize: "32px", fontWeight: "600" }} className="mt-1">
            Formulir Pendaftaran
          </h1>
        )}
        {size.width < 500 ? (
          <p style={{ fontSize: "12px" }} className="mt-2">
            Selamat datang di website registrasi online prasmul-eli!
          </p>
        ) : (
          <p style={{ fontSize: "24px", fontWeight: "500" }} className="mt-2">
            Selamat datang di website registrasi online prasmul-eli!
          </p>
        )}
      </div>
      <div className="col-lg-12 img-progress-page-desktop">
        <ImageProgressPage page={page} />
      </div>
      <div className="col-lg-8 card-wrapper-desktop">
        <div
          className="card"
          style={{
            backgroundColor: "#F2F2F2",
            marginBottom: "5%",
            borderRadius: "20px",
            height: size.width < 500 ? "600px" : "",
            overflowX: size.width < 500 ? "scroll" : "",
          }}
        >
          <div className="card-body">
            <CardBodyComp page={page} />
          </div>
        </div>
        <div className="d-flex justify-content-between mb-5">
          {localStorage.getItem("access_token") ? (
            <div></div>
          ) : (
            <>
              {page < 7 && page !== 1 ? (
                <button
                  class="btn btn-ghost-success"
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                  }}
                  onClick={previous}
                >
                  Kembali
                </button>
              ) : page === 7 ? (
                <div className="col-6 text-left">
                  <button
                    class="btn btn-ghost-success"
                    style={{
                      fontSize: size.width < 500 ? "15px" : "20px",
                      fontWeight: "400",
                    }}
                    onClick={previous}
                  >
                    Kembali
                  </button>
                </div>
              ) : page === 8 ? (
                <div></div>
              ) : (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#0C86D9",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-primary"
                  onClick={handleLogin}
                >
                  Login
                </button>
              )}
            </>
          )}

          {(page === 5 &&
            categoryUser.value === "individu" &&
            dataInputRegistration.isUsingReferral === false &&
            dataInputRegistration.isUsingEarlyBird === true) ||
            (page === 5 &&
              categoryUser.value === "corporate" &&
              dataInputRegistration.isUsingReferral === false &&
              dataInputRegistration.isUsingEarlyBird === true) ? (
            <button
              style={{
                fontSize: size.width < 500 ? "15px" : "20px",
                fontWeight: "400",
                backgroundColor: "#26D07C",
                color: "#F2F2F2",
              }}
              type="button"
              className="btn"
              onClick={() => setShowPembayaranIndividu(true)}
              disabled={dataInputRegistration.disabledRegistration}
            >
              {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Lanjutkan Pembayaran'}
            </button>
          ) : page === 5 &&
            categoryUser.value === "corporate" &&
            dataInputRegistration.isUsingEarlyBird === false &&
            dataInputRegistration.isUsingReferral === true ? (
            <button
              style={{
                fontSize: size.width < 500 ? "15px" : "20px",
                fontWeight: "400",
                backgroundColor: "#26D07C",
                color: "#F2F2F2",
              }}
              type="button"
              className="btn"
              onClick={() => setShowPembayaranIndividu(true)}
              disabled={dataInputRegistration.disabledRegistration}
            >
              {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Lanjutkan Pembayaran'}
            </button>
          ) : page === 5 &&
            showOpsiBtnBayar === true &&
            dataInputRegistration.isEarlyBird === false ? (
            <div>
              {categoryUser.value === "corporate" ? (
                <>
                  <button
                    style={{
                      fontSize: size.width < 500 ? "15px" : "20px",
                      fontWeight: "400",
                    }}
                    type="button"
                    className="btn btn-outline-success"
                    onClick={handleToGlPage}
                    disabled={dataInputRegistration.disabledRegistration}
                  >
                    {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar Nanti'}
                  </button>
                  &nbsp; &nbsp;
                  <button
                    style={{
                      fontSize: size.width < 500 ? "15px" : "20px",
                      fontWeight: "400",
                    }}
                    type="button"
                    className="btn btn-success"
                    onClick={handleCheckout}
                    disabled={dataInputRegistration.disabledRegistration}
                  >
                    {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar Sekarang'}
                  </button>
                </>
              ) : (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleCheckout}
                  disabled={dataInputRegistration.disabledRegistration}
                >
                  {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Bayar Sekarang'}
                </button>
              )}
            </div>
          ) : page === 7 && categoryUser.value === "individu" ? (
            <button
              style={{
                fontSize: size.width < 500 ? "15px" : "20px",
                fontWeight: "400",
                backgroundColor: "#26D07C",
                color: "#F2F2F2",
              }}
              type="button"
              className="btn"
              onClick={cekStatusPembayaranIndividu}
            >
              Cek Status Pembayaran
            </button>
          ) : page === 6 && categoryUser.value === "corporate" ? (
            <div className="col-6 text-right">
              {/* <button style={{ fontSize: size.width < 500 ? '15px' : '20px', fontWeight: '400' }} type='button' className='btn btn-outline-success' onClick={() => handlePaymentCorporate(false)}>Upload Nanti</button>
                    &nbsp;&nbsp; */}
              <button
                style={{
                  fontSize: size.width < 500 ? "15px" : "20px",
                  fontWeight: "400",
                  backgroundColor: "#26D07C",
                  color: "#F2F2F2",
                }}
                type="button"
                className="btn"
                onClick={() => handleCheckout()}
                disabled={dataInputRegistration.disabledRegistration}
              >
                {dataInputRegistration.disabledRegistration ? 'Mohon Tunggu..' : 'Checkout Now!'}
              </button>
              {/* <button style={{ fontSize: size.width < 500 ? '15px' : '20px', fontWeight: '400', backgroundColor: '#26D07C', color: '#F2F2F2' }} type='button' className='btn' onClick={() => handlePaymentCorporate(true)}>Checkout Now!</button> */}
            </div>
          ) : page === 8 && categoryUser.value === "corporate" ? (
            <div></div>
          ) : (
            <button
              style={{
                fontSize: size.width < 500 ? "15px" : "20px",
                fontWeight: "400",
                backgroundColor: "#26D07C",
                color: "#F2F2F2",
              }}
              type="button"
              className="btn"
              onClick={next}
              disabled={dataInputRegistration.disabledRegistration}
            >
              Lanjutkan
            </button>
          )}
        </div>
      </div>

      <div className="col-lg-12">
        <PolicyFooter />
      </div>

      <Modal
        show={showPembayaranIndividu}
        size="lg"
        onHide={() => setShowPembayaranIndividu(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="mt-3 mb-3">Pembayaran</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SummaryPembayaranIndividu
            checkOutMidtrans={handleCheckout}
            checkOutXenditCorporate={handleCheckout}
            checkOutManualCorporate={updateStateManualPayment}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalEarlyBird}
        size="lg"
        onHide={() => setshowModalEarlyBird(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            <h2 className="mt-2 mb-2 text-success">Selamat</h2>
            <h3 className="mt-2 mb-2">
              Anda Telah Mendapatkan{" "}
              <span className="text-warning">Diskon Early Bird!</span>
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalEarlyBird
            activateEarlyBird={handleActivateEarlyBird}
            skipEarlyBird={handleSkipEarlyBird}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalNonEarlyBird}
        size="lg"
        onHide={() => setshowModalNonEarlyBird(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalNonEarlyBird showOpsiBtnBayar={handleOpsiBtnBayar} />
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalInfoSkipEarlyBird}
        size="md"
        onHide={() => setshowModalInfoSkipEarlyBird(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="mt-3 mb-3">Konfirmasi Pembayaran</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalConfirmSkipEarlyBird
            activateEarlyBird={handleActivateEarlyBirdAgain}
            nextToGlPage={handleToGlPage}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RegistrationPage;
